<template>
  <div aria-live="assertive" class="pointer-events-none inset-0 flex items-end px-1 py-1 sm:items-start sm:p-1 z-50">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon v-if="response.item.type === 'success'" class="h-6 w-6 text-green-400" aria-hidden="true" />
                <XCircleIcon v-else class="h-6 w-6 text-red-400" aria-hidden="true" />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p v-if="response.item.type === 'success'" class="text-sm font-medium text-gray-900">{{ response.item.title }}</p>
                <p v-else class="text-sm font-medium text-gray-900">{{ response.item.title }}</p>
                <p class="mt-1 text-sm text-gray-500">{{ response.item.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'

export default {
  name: "NotificationsComponent",
  props: ['response'],

  components: {
    CheckCircleIcon,
    XMarkIcon,
    XCircleIcon,
  },
}
</script>